import type { SVGProps } from "react";
import MicLinear from "~icons/solar/microphone-linear";

/**
 * The single source of icons for the app (Solar, linear style; bold reserved
 * for active/selected states). Components import from here, never directly.
 */
export { default as IconFeed } from "~icons/solar/home-2-linear";
export { default as IconFeedActive } from "~icons/solar/home-2-bold";
export { default as IconCommunities } from "~icons/solar/widget-linear";
export { default as IconCommunitiesActive } from "~icons/solar/widget-bold";
export { default as IconExplore } from "~icons/solar/compass-linear";
export { default as IconExploreActive } from "~icons/solar/compass-bold";
export { default as IconMessages } from "~icons/solar/letter-linear";
export { default as IconMessagesActive } from "~icons/solar/letter-bold";
export { default as IconBell } from "~icons/solar/bell-linear";
export { default as IconBellActive } from "~icons/solar/bell-bold";
export { default as IconUser } from "~icons/solar/user-rounded-linear";
export { default as IconUserActive } from "~icons/solar/user-rounded-bold";
export { default as IconUsers } from "~icons/solar/users-group-rounded-linear";
export { default as IconSearch } from "~icons/solar/magnifer-linear";
export { default as IconAdd } from "~icons/solar/add-circle-linear";
export { default as IconPlus } from "~icons/solar/add-square-linear";
export { default as IconCompose } from "~icons/solar/pen-new-square-linear";
export { default as IconEdit } from "~icons/solar/pen-2-linear";
export { default as IconHeart } from "~icons/solar/heart-linear";
export { default as IconHeartFilled } from "~icons/solar/heart-bold";
export { default as IconComment } from "~icons/solar/chat-round-line-linear";
export { default as IconRepost } from "~icons/solar/repeat-linear";
export { default as IconQuote } from "~icons/solar/quote-linear";
export { default as IconShare } from "~icons/solar/share-linear";
export { default as IconLink } from "~icons/solar/link-minimalistic-2-linear";
export { default as IconCopy } from "~icons/solar/copy-linear";
export { default as IconMore } from "~icons/solar/menu-dots-linear";
export { default as IconTrash } from "~icons/solar/trash-bin-minimalistic-linear";
export { default as IconSettings } from "~icons/solar/settings-linear";
export { default as IconLogout } from "~icons/solar/logout-2-linear";
export { default as IconSun } from "~icons/solar/sun-2-linear";
export { default as IconMoon } from "~icons/solar/moon-linear";
export { default as IconMonitor } from "~icons/solar/monitor-linear";
export { default as IconHash } from "~icons/solar/hashtag-linear";
export { default as IconVolume } from "~icons/solar/volume-loud-linear";
export { default as IconSpeaker } from "~icons/solar/volume-loud-linear";
export { default as IconMic } from "~icons/solar/microphone-linear";
export { default as IconHeadphones } from "~icons/solar/headphones-round-linear";
export { default as IconDeafened } from "~icons/solar/volume-cross-linear";
export { default as IconHangUp } from "~icons/solar/phone-rounded-linear";
export { default as IconImage } from "~icons/solar/gallery-add-linear";
export { default as IconGallery } from "~icons/solar/gallery-wide-linear";
export { default as IconSmile } from "~icons/solar/smile-circle-linear";
export { default as IconReply } from "~icons/solar/reply-linear";
export { default as IconPin } from "~icons/solar/pin-linear";
export { default as IconPinFilled } from "~icons/solar/pin-bold";
export { default as IconClose } from "~icons/solar/close-linear";
export { default as IconX } from "~icons/solar/close-linear";
export { default as IconCheck } from "~icons/solar/check-circle-linear";
export { default as IconCheckRead } from "~icons/solar/check-read-linear";
export { default as IconChevronDown } from "~icons/solar/alt-arrow-down-linear";
export { default as IconChevronRight } from "~icons/solar/alt-arrow-right-linear";
export { default as IconChevronLeft } from "~icons/solar/alt-arrow-left-linear";
export { default as IconBack } from "~icons/solar/arrow-left-linear";
export { default as IconArrowUp } from "~icons/solar/arrow-up-linear";
export { default as IconShield } from "~icons/solar/shield-user-linear";
export { default as IconCrown } from "~icons/solar/crown-minimalistic-linear";
export { default as IconLock } from "~icons/solar/lock-keyhole-minimalistic-linear";
export { default as IconGlobe } from "~icons/solar/global-linear";
export { default as IconEye } from "~icons/solar/eye-linear";
export { default as IconInfo } from "~icons/solar/info-circle-linear";
export { default as IconDanger } from "~icons/solar/danger-triangle-linear";
export { default as IconCalendar } from "~icons/solar/calendar-minimalistic-linear";
export { default as IconLocation } from "~icons/solar/map-point-linear";
export { default as IconSend } from "~icons/solar/plain-2-linear";
export { default as IconPlay } from "~icons/solar/play-bold";
export { default as IconFire } from "~icons/solar/fire-minimalistic-linear";
export { default as IconUserPlus } from "~icons/solar/user-plus-rounded-linear";
export { default as IconUserMinus } from "~icons/solar/user-minus-rounded-linear";
export { default as IconUserCheck } from "~icons/solar/user-check-rounded-linear";
export { default as IconBlock } from "~icons/solar/user-block-rounded-linear";
export { default as IconSidebar } from "~icons/solar/users-group-two-rounded-linear";
export { default as IconMention } from "~icons/solar/mention-circle-linear";
export { default as IconFolder } from "~icons/solar/folder-2-linear";
export { default as IconLogin } from "~icons/solar/login-2-linear";
export { default as IconExport } from "~icons/solar/square-share-line-linear";
export { default as IconStar } from "~icons/solar/star-linear";
export { default as IconInbox } from "~icons/solar/inbox-linear";
export { default as IconHistory } from "~icons/solar/history-linear";
export { default as IconReorder } from "~icons/solar/reorder-linear";
export { default as IconArrowRightUp } from "~icons/solar/arrow-right-up-linear";
export { default as IconArrowRight } from "~icons/solar/arrow-right-linear";
export { default as IconWifiOff } from "~icons/solar/wi-fi-router-minimalistic-linear";
export { default as IconText } from "~icons/solar/text-field-linear";
export { default as IconBold } from "~icons/solar/text-bold-linear";
export { default as IconItalic } from "~icons/solar/text-italic-linear";
export { default as IconCode } from "~icons/solar/code-linear";
export { default as IconHourglass } from "~icons/solar/hourglass-linear";
export { default as IconCamera } from "~icons/solar/camera-minimalistic-linear";
export { default as IconSignal } from "~icons/solar/soundwave-linear";
export { default as IconEnvelope } from "~icons/solar/letter-opened-linear";

export { default as IconKeyboard } from "~icons/solar/keyboard-linear";
export { default as IconMouse } from "~icons/solar/mouse-minimalistic-linear";
export { default as IconCard } from "~icons/solar/card-linear";
export { default as IconWallet } from "~icons/solar/wallet-linear";
export { default as IconBill } from "~icons/solar/bill-list-linear";
export { default as IconWidget } from "~icons/solar/widget-4-linear";
export { default as IconPlug } from "~icons/solar/plug-circle-linear";
export { default as IconPalette } from "~icons/solar/palette-linear";
export { default as IconShieldCheck } from "~icons/solar/shield-check-linear";
export { default as IconShieldWarning } from "~icons/solar/shield-warning-linear";
export { default as IconKey } from "~icons/solar/key-minimalistic-linear";
export { default as IconDevices } from "~icons/solar/devices-linear";
export { default as IconLaptop } from "~icons/solar/laptop-minimalistic-linear";
export { default as IconSmartphone } from "~icons/solar/smartphone-linear";
export { default as IconTranslation } from "~icons/solar/translation-linear";
export { default as IconAccessibility } from "~icons/solar/accessibility-linear";
export { default as IconCodeSquare } from "~icons/solar/code-square-linear";
export { default as IconDownload } from "~icons/solar/download-minimalistic-linear";
export { default as IconSort } from "~icons/solar/sort-vertical-linear";
export { default as IconTuning } from "~icons/solar/tuning-2-linear";
export { default as IconMedal } from "~icons/solar/medal-ribbon-star-linear";
export { default as IconTag } from "~icons/solar/tag-linear";
export { default as IconSticker } from "~icons/solar/sticker-smile-circle-linear";
export { default as IconServer } from "~icons/solar/server-minimalistic-linear";
export { default as IconStars } from "~icons/solar/stars-minimalistic-linear";
export { default as IconHelp } from "~icons/solar/question-circle-linear";
export { default as IconLightbulb } from "~icons/solar/lightbulb-minimalistic-linear";
export { default as IconHandshake } from "~icons/solar/hand-shake-linear";
export { default as IconDocument } from "~icons/solar/document-text-linear";
export { default as IconClipboard } from "~icons/solar/clipboard-text-linear";
export { default as IconLayers } from "~icons/solar/layers-minimalistic-linear";
export { default as IconBellOff } from "~icons/solar/bell-off-linear";
export { default as IconGift } from "~icons/solar/gift-linear";
export { default as IconRocket } from "~icons/solar/rocket-2-linear";
export { default as IconBolt } from "~icons/solar/bolt-linear";
export { default as IconIdCard } from "~icons/solar/user-id-linear";
export { default as IconPassword } from "~icons/solar/password-minimalistic-linear";
export { default as IconTimer } from "~icons/solar/stopwatch-linear";
export { default as IconCrownStar } from "~icons/solar/crown-star-linear";
export { default as IconBrush } from "~icons/solar/paint-brush-linear";
export { default as IconRefresh } from "~icons/solar/refresh-linear";
export { default as IconExternal } from "~icons/solar/square-arrow-right-up-linear";
export { default as IconMinus } from "~icons/solar/minus-circle-linear";
export { default as IconDrag } from "~icons/solar/hamburger-menu-linear";
export { default as IconSliders } from "~icons/solar/tuning-square-2-linear";
export { default as IconChatLine } from "~icons/solar/chat-line-linear";
export { default as IconCrop } from "~icons/solar/crop-minimalistic-linear";

/** Solar has no megaphone; drawn in the same 1.5px outline style. Used for announcement channels. */
export function IconAnnouncement(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="1.2em" height="1.2em" {...props}>
      {/* Horn flaring to an open bell (no sound waves, so it doesn't read as the voice speaker). */}
      <path d="M4.5 9.5h2.2L17 4.8v14.4L6.7 14.5H4.5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1Z" />
      <ellipse cx="17.6" cy="12" rx="1.6" ry="7.2" />
      <path d="M6.8 14.6 8.3 19.4a1 1 0 0 0 1 .7h.7a.9.9 0 0 0 .9-1.1l-1-4" />
    </svg>
  );
}

/** Solar has no slashed microphone; compose one in the same stroke style. */
export function IconMicOff(props: SVGProps<SVGSVGElement>) {
  return (
    <span className="relative inline-flex">
      <MicLinear {...props} />
      <svg viewBox="0 0 24 24" className={props.className ?? "icon"} style={{ position: "absolute", inset: 0 }} aria-hidden>
        <path d="M4 4l16 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </span>
  );
}

/* Settings additions. */
export { default as IconTick } from "~icons/solar/check-linear";
export { default as IconDatabase } from "~icons/solar/database-linear";
export { default as IconClock } from "~icons/solar/clock-circle-linear";
export { default as IconMusicNote } from "~icons/solar/music-note-linear";
export { default as IconMoonSleep } from "~icons/solar/moon-sleep-linear";
export { default as IconRestart } from "~icons/solar/restart-linear";
export { default as IconBug } from "~icons/solar/bug-minimalistic-linear";

/* Phase 2 */
export { default as IconPoll } from "~icons/solar/chart-2-linear";
export { default as IconAlarm } from "~icons/solar/alarm-linear";
export { default as IconBookmark } from "~icons/solar/bookmark-linear";
export { default as IconBookmarkFilled } from "~icons/solar/bookmark-bold";
export { default as IconForward } from "~icons/solar/forward-linear";
export { default as IconFlag } from "~icons/solar/flag-linear";
export { default as IconEyeOff } from "~icons/solar/eye-closed-linear";
export { default as IconWarning } from "~icons/solar/danger-triangle-linear";
export { default as IconTrophy } from "~icons/solar/cup-star-linear";
export { default as IconLeaf } from "~icons/solar/leaf-linear";
export { default as IconHammer } from "~icons/solar/shield-user-linear";
export { default as IconCommand } from "~icons/solar/command-linear";
export { default as IconPaperclip } from "~icons/solar/paperclip-linear";
export { default as IconFile } from "~icons/solar/file-linear";
export { default as IconVideo } from "~icons/solar/videocamera-linear";
export { default as IconGraph } from "~icons/solar/graph-up-linear";
export { default as IconBot } from "~icons/solar/ghost-linear";
export { default as IconSlashCommand } from "~icons/solar/slash-square-linear";
export { default as IconProgramming } from "~icons/solar/programming-linear";
export { default as IconWebhook } from "~icons/solar/plug-circle-linear";
export { default as IconUndo } from "~icons/solar/undo-left-linear";
export { default as IconChecklist } from "~icons/solar/checklist-minimalistic-linear";
export { default as IconCalendarAdd } from "~icons/solar/calendar-add-linear";
export { default as IconMagic } from "~icons/solar/magic-stick-3-linear";
export { default as IconStrike } from "~icons/solar/text-cross-linear";
export { default as IconList } from "~icons/solar/list-linear";
export { default as IconMinusCircle } from "~icons/solar/minus-circle-linear";
export { default as IconLive } from "~icons/solar/record-circle-linear";
export { default as IconGamepad } from "~icons/solar/gamepad-linear";
export { default as IconTv } from "~icons/solar/tv-linear";
export { default as IconCase } from "~icons/solar/case-linear";
export { default as IconEmoji } from "~icons/solar/emoji-funny-circle-linear";
export { default as IconFriends } from "~icons/solar/users-group-two-rounded-linear";
export { default as IconPlanet } from "~icons/solar/planet-linear";
export { default as IconSpoiler } from "~icons/solar/eye-closed-linear";

/* Rail folders */
export { default as IconBook } from "~icons/solar/book-minimalistic-linear";
export { default as IconFolderOpen } from "~icons/solar/folder-open-linear";
export { default as IconFolderAdd } from "~icons/solar/add-folder-linear";
export { default as IconFolderRemove } from "~icons/solar/remove-folder-linear";
export { default as IconFolderMove } from "~icons/solar/move-to-folder-linear";
export { default as IconUngroup } from "~icons/solar/folders-linear";

/* Chat: formatting, GIFs */
export { default as IconUnderline } from "~icons/solar/text-underline-linear";

/** Solar has no GIF glyph; a rounded tag with the letters, in the same 1.5px outline style. */
export function IconGif(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="1.2em" height="1.2em" {...props}>
      <rect x="2.75" y="5.75" width="18.5" height="12.5" rx="3" />
      <path d="M10 10.2a1.9 1.9 0 0 0-1.6-.95c-1.1 0-1.9.85-1.9 2.75s.8 2.75 1.9 2.75c.95 0 1.6-.65 1.6-1.75H8.6" />
      <path d="M12.5 9.25v5.5" />
      <path d="M17.5 9.25h-2.4v5.5M15.1 12h1.9" />
    </svg>
  );
}

/* Community: forums, onboarding */
export { default as IconForum } from "~icons/solar/chat-square-line-linear";
export { default as IconMediaChannel } from "~icons/solar/gallery-minimalistic-linear";
export { default as IconUnlock } from "~icons/solar/lock-keyhole-minimalistic-unlocked-linear";
export { default as IconSortTime } from "~icons/solar/sort-by-time-linear";

/* Voice: calls, screen share and stages */
export { default as IconCall } from "~icons/solar/phone-calling-rounded-linear";
export { default as IconEndCall } from "~icons/solar/end-call-rounded-linear";
export { default as IconScreenShare } from "~icons/solar/screen-share-linear";
export { default as IconScreenShareActive } from "~icons/solar/screen-share-bold";
export { default as IconStage } from "~icons/solar/podcast-linear";
export { default as IconHandUp } from "~icons/solar/user-hand-up-linear";
export { default as IconHandUpActive } from "~icons/solar/user-hand-up-bold";
export { default as IconInviteToSpeak } from "~icons/solar/user-speak-rounded-linear";
export { default as IconFullscreen } from "~icons/solar/full-screen-linear";
export { default as IconFullscreenExit } from "~icons/solar/quit-full-screen-linear";
export { default as IconFocus } from "~icons/solar/maximize-square-minimalistic-linear";
export { default as IconUnfocus } from "~icons/solar/minimize-square-minimalistic-linear";
export { default as IconPip } from "~icons/solar/to-pip-linear";
export { default as IconPipExit } from "~icons/solar/quit-pip-linear";
export { default as IconSwapSource } from "~icons/solar/square-transfer-horizontal-linear";
export { default as IconStopStream } from "~icons/solar/stop-circle-linear";
export { default as IconStreamMuted } from "~icons/solar/volume-cross-linear";
export { default as IconStreamVolume } from "~icons/solar/volume-loud-linear";
/* Staff console */
export { default as IconSuspend } from "~icons/solar/forbidden-circle-linear";
export { default as IconOverview } from "~icons/solar/chart-square-linear";
